export default __webpack_public_path__ + "static/media/A93.05525cd9.png";